module.exports = __webpack_public_path__ + "img/Eyezen-BOOST-long-noir.8839cde3.svg";